export const PAYMENT_OPTIONS = {
  SEPA: 'sepa_debit',
  CREDIT_CARD: 'card',
}
